import { render, staticRenderFns } from "./transactions.vue?vue&type=template&id=bd5bab88"
import script from "./transactions.vue?vue&type=script&lang=js"
export * from "./transactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports